import {
  InputWithLabel,
  InputWithLabelProps,
} from '../inputWithLabel/InputWithLabel';
import { InputWithDisclaimerWrapper, StyledDisclaimer } from './styled';

export interface InputWithDisclaimerProps extends InputWithLabelProps {
  disclaimer: string;
}

export const InputWithDisclaimer: React.FC<InputWithDisclaimerProps> = ({
  disclaimer,
  ...props
}) => (
  <InputWithDisclaimerWrapper>
    <InputWithLabel {...props} />
    <StyledDisclaimer>{disclaimer}</StyledDisclaimer>
  </InputWithDisclaimerWrapper>
);
